// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

//import en from './locales/en.json';
//import ja from './locales/ja.json';
import en from './assets/i18n/en.json';
import ja from './assets/i18n/ja.json';
//import en from './i18n/en.json';
//import ja from './i18n/ja.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ja: { translation: ja },
    },
    //lng: 'ja', // default
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
